const PostingStatus = Object.freeze({
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
});

export default PostingStatus;
